import { useEffect, useRef } from 'react';

// credit to https://usehooks.com/usePrevious/

export const usePrevious = <T>(value: T): T => {
    // The ref object is a generic container whose current property is mutable
    // and can hold any value, similar to an instance property on a class
    const ref: any = useRef<T>(undefined); // eslint-disable-line @typescript-eslint/no-explicit-any

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
};
